import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b1a1cf4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5b1a1cf4&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=5b1a1cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a1cf4",
  null
  
)

export default component.exports